module.exports = __webpack_public_path__ + "img/logo-icon-white.8c01ca57.png";